// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"8b932f25","170":"c2f817d8","453":"a2de1bb7","455":"8696d5ed","857":"fff21746","970":"cc3d719b","977":"61537a3d"}[chunkId] + ".chunk.js";
};